import {
  SET_APP_LOADING,
  SET_APP_LOADING_SAMPLES
} from '../constants/actionTypes';

const initialState = {
  samples: false,
  app: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_APP_LOADING_SAMPLES:
      return { ...state, samples: action.payload };
    case SET_APP_LOADING:
      return { ...state, loading: action.payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/loading.js